import ShowDisableConditionally from '@/modules/form/mixins/show-disable-conditionally';
import PrepareFieldsConfig from '@/modules/form/mixins/prepare-fields-config';

export default {
  mixins: [ShowDisableConditionally, PrepareFieldsConfig],
  methods: {
    columnClass(column) {
      if (this.$vuetify.breakpoint.smAndUp) {
        return column.class;
      }
      return null;
    },
    prepareConfig(fieldsConfig) {
      return fieldsConfig.map(fieldConfig => this.prepareFieldConfig(fieldConfig, this.scopeId, this.scope));
    },
  },
};
